export const baseCondition: { [key: string]: any } = {
  value      : [],
  filters    : [ "CaseInsensitive" ],
  invert     : false,
}
